module.exports = __webpack_public_path__ + "static/media/whiteGoBackTransparent.d0ffa351.svg";